import { render, staticRenderFns } from "./customerservice.vue?vue&type=template&id=2274f67e&scoped=true&"
import script from "./customerservice.vue?vue&type=script&lang=js&"
export * from "./customerservice.vue?vue&type=script&lang=js&"
import style0 from "./customerservice.vue?vue&type=style&index=0&id=2274f67e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2274f67e",
  null
  
)

export default component.exports